function modifyArrayOfObjectsKeys(array, keyMap) {
    return array.map((object, index) => {
      const modifiedObject = {};
      for (const key in object) {
        if (keyMap[key]) {
          modifiedObject[keyMap[key]] = object[key];
        } else {
          modifiedObject[key] = object[key];
        }
      }
      return modifiedObject;
    });
  }
  
  export default modifyArrayOfObjectsKeys;

  export function isMobileDevice() {
    const userAgent = navigator.userAgent.toLowerCase();
    const mobileKeywords = ['iphone', 'ipod', 'android', 'blackberry', 'windows phone', 'opera mini', 'mobile', 'tablet'];

    return mobileKeywords.some(keyword => userAgent.includes(keyword));
}
